import { memo } from "react";
import { useRepositoryContext } from "../Repository";
import { NotificationsRepository } from "./repository";
import CodeSnippet from "ui/molecules/CodeSnippet";

const Notifications = <TNotification extends object>() => {
    const repository = useRepositoryContext<NotificationsRepository<TNotification>>();

    return (
        <CodeSnippet
            data={repository.data}
        />
    );
};

export default memo(Notifications);
